"use client";

import { LanguageContext } from "@/context/languageContext";
import { ContentComponent } from "@/types/modules";
import { Restaurant } from "@/types/wordpress";
import { notFound } from "next/navigation";
import { useContext, useEffect } from "react";
import Splash from "../Splash";
import Content from "../Content";
import OpeningTimes from "./OpeningTimes";
import ViewAll from "../ViewAll";
import Featured from "../Featured";
import { translate } from "@/utils/translate";
import { useLanguageUrl } from "@/context/languageURLContext";

interface RestaurantComponentProps {
  restaurant: Restaurant;
}

export default function RestaurantComponent({
  restaurant,
}: RestaurantComponentProps) {
  const { language } = useContext(LanguageContext);
  const { setUrl } = useLanguageUrl(); // Access context values

  useEffect(() => {
    setUrl(restaurant.translations[0].uri);
  }, [restaurant.translations, setUrl]);

  if (restaurant === null) {
    notFound();
  }

  const content: ContentComponent = {
    imageAlign: restaurant.contentFields.imageAlign,
    textAlign: restaurant.contentFields.textAlign,
    content: restaurant.contentFields.body,
    gallery: restaurant.contentFields.gallery,
    button: restaurant.contentFields.button,
    ...(restaurant.contentFields.title && {
      title: restaurant.contentFields.title,
    }),
  };

  return (
    <>
      {restaurant.slider && restaurant.slider.slider && (
        <Splash slider={restaurant.slider.slider} />
      )}
      <section className="content">
        <div className="contentContainer">
          <Content content={content} />
        </div>
      </section>
      <OpeningTimes openingTimes={restaurant.restaurantsOpeningtimes} />
      <ViewAll
        text={translate["backToRestaurants"][language]}
        link={`/${language}/restaurants`}
      />
      <Featured featured={restaurant.featured} />
    </>
  );
}
